var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4102 20.8325C15.9316 20.8325 20.4102 16.354 20.4102 10.8325C20.4102 5.31108 15.9316 0.83252 10.4102 0.83252C4.88872 0.83252 0.410156 5.31108 0.410156 10.8325C0.410156 16.354 4.88872 20.8325 10.4102 20.8325ZM9.69585 5.11824C9.69585 4.72537 10.0173 4.40394 10.4102 4.40394C10.803 4.40394 11.1245 4.72537 11.1245 5.11824V10.4897L14.428 13.1325C14.7352 13.379 14.7852 13.8289 14.5387 14.1361C14.472 14.2198 14.3873 14.2874 14.2908 14.3338C14.1943 14.3802 14.0886 14.4042 13.9816 14.4039C13.8244 14.4039 13.6673 14.3539 13.5352 14.2468L9.96375 11.3897C9.7959 11.2539 9.69591 11.0504 9.69591 10.8325V5.11824H9.69585Z",
    fill: "#22B573"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.3f78718cef1f8aa9392ca384a4433644.svg";
export { ForwardRef as ReactComponent };